import { RegularButton, Typography } from 'fronton-react';
import { rowMargin, VerifyCodeLabel } from './styles';
import React from 'react';
import { t } from 'i18next';
import { useCountDown } from 'common/hooks/use-count-down';

interface IResendButton {
  resend: () => void;
  loading: boolean;
}

export const ResendButton: React.FC<IResendButton> = ({ resend, loading }) => {
  const { timer, resetTimer } = useCountDown({ start: 60 });

  const handleResend = () => {
    resetTimer();
    resend();
  };

  return timer === 0 ? (
    <RegularButton
      className={rowMargin}
      data-qa="resend-code-button"
      loading={loading}
      wide
      variant="accent"
      size="l"
      onClick={handleResend}
    >
      {t('loyalty-registration-modal.verify-code-step.resend-code')}
    </RegularButton>
  ) : (
    <VerifyCodeLabel data-qa="wait-timer" className={rowMargin}>
      <Typography variant="s" size="body_long" color="text-secondary">
        {t('loyalty-registration-modal.verify-code-step.new-code-can-resend')}
      </Typography>
      <Typography variant="s" size="body_long" color="text-secondary">
        {t('loyalty-registration-modal.verify-code-step.after-seconds', { count: timer })}
      </Typography>
    </VerifyCodeLabel>
  );
};
